import { PercentageOrEmpty } from '../typography/percentage-or-empty.tsx';

type MarginPercentageProps = {
    margin: number | string | null | undefined;
    revenue: number | string | null | undefined;
    decimals?: number;
    showEmptyIfZero?: boolean;
};

export function MarginPercentage({
    margin,
    revenue,
    decimals = 0,
    showEmptyIfZero = true,
}: MarginPercentageProps) {
    const revenueNum = Number(revenue);
    const marginNum = Number(margin);
    const marginPercent = !Number.isNaN(revenueNum) && revenueNum !== 0 ? marginNum / revenueNum : undefined;

    return (
        <PercentageOrEmpty decimals={decimals} showEmptyIfZero={showEmptyIfZero}>
            {marginPercent}
        </PercentageOrEmpty>
    );
}
